import { FC, useEffect, useState } from 'react'
import { CommonProductComponent } from '../ComonProduct'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

import { getParsedMenuItems } from 'featureSliced/shared/utils/getParsedMenuItems'
import { convertToPrice } from 'featureSliced/shared/utils/convertToPrice'
import { UpdateProductFooter } from '../footers/UpdateProductFooter'
import {
  IBucketProduct,
  IProductWithBucketProduct,
} from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

type UpdateProductProps = {
  product: IProductWithBucketProduct
  bucketProduct: IBucketProduct
  closeProduct: () => void
}

export const UpdateProduct: FC<UpdateProductProps> = ({
  product,
  bucketProduct,
  closeProduct,
}) => {
  // Hooks
  const currency = useMySelector((state) => state.app.companyData).Currency

  // State
  const [currentAmount, setCurrentAmount] = useState(1)

  // useEffect
  useEffect(() => {
    if (product.count) {
      setCurrentAmount(product.count)
    }
  }, [product.count])

  // TODO: duplicates. move to helpers
  const getIncludedItemPrice = (price = 0, count = 0) => {
    if (price && count) {
      return `${count} x ${convertToPrice(price)} ${currency || ''}`
    }
    if (!price && count) {
      return `x ${count}`
    }
    if (price && !count) {
      return `${convertToPrice(price)} ${currency || ''}`
    }
    if (!price && !count) {
      return ''
    }
    return ''
  }

  return (
    <>
      <CommonProductComponent
        product={product as unknown as IProduct}
        productTemplateId={bucketProduct.productTemplateId}
        kitchenInfoState={[
          JSON.parse(product.kitchenInfo || '{}'),
          () => undefined,
        ]}
        currentAmount={currentAmount}
      />
      {getParsedMenuItems(product?.menuItems)?.map((currentItem: any) => (
        <p
          key={`includedItem_${currentItem.productId}_${currentItem.recordGuid}`}
          style={{
            marginTop: '-40px',
            marginBottom: '40px',
          }}
        >{`${currentItem.name} (${getIncludedItemPrice(
          currentItem.price,
          product?.count
        )})`}</p>
      ))}
      <UpdateProductFooter
        product={product}
        bucketProduct={bucketProduct}
        closeProduct={closeProduct}
        currentAmount={currentAmount}
        setCurrentAmount={setCurrentAmount}
      />
    </>
  )
}
